import './css/LandingBackground.css'

import commit_example from '../assets/images/commit-example.png'

const COMMIT_ROW = [commit_example, commit_example, commit_example, commit_example, commit_example, commit_example,commit_example, commit_example,commit_example, commit_example,commit_example, commit_example,];

const LandingBackground = () => {
    return (
        <div className="landing-background">
            <div className="container">
                {[...Array(16)].map((_, index) => {
                    const isEven = index % 2 === 0;
                    const baseSpeed = 300; // base speed in seconds
                    const speedVariation = Math.floor(Math.random() * 400); // between 0 and 400s
                    const animationDuration = `${baseSpeed + speedVariation}s`;

                    return (
                        <div
                            key={index}
                            className={`row ${isEven ? 'scroll-right' : 'scroll-left'}`}
                            style={{ animation: `${isEven ? 'scroll-right' : 'scroll-left'} ${animationDuration} linear infinite` }}
                        >
                            {[...COMMIT_ROW, ...COMMIT_ROW].map((commit_src, imgIndex) => (
                                <img key={imgIndex} src={commit_src} alt="" />
                            ))}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default LandingBackground;